export default {"src":"/_next/static/media/9.de126c15.svg","height":140,"width":120,"blurWidth":0,"blurHeight":0};